import IPublicParcelState from "../auction/IPublicParcelState";
import { IParcelBidLog } from "../parcel/IParcelBidLog";
import { BidLoadState } from "../utility/LoadState";

export default class AuctionsHub {
    public static readonly ReceiveCommands = {
        ReceiveApprovedParcelBid: "ReceiveApprovedParcelBid",
        ReceiveBatchLiveStatus: "ReceiveBatchLiveStatus",
        ReceiveParcelBidLogUpdate: "ReceiveParcelBidLogUpdate",
        ReceiveParcelClocksUpdate: "ReceiveParcelClocksUpdate",
        ReceivePublicParcelState: "ReceivePublicParcelState",
        ReceiveBidderEnBlocApproval: "ReceiveBidderEnBlocApproval",
        ReceiveAdminEnBlocApprovedBidders: "ReceiveAdminEnBlocApprovedBidders",
        BidProcessingComplete: "BidProcessingComplete"
    };
    public static readonly DebugCommands = {
        ReceiveLatencyTestResults: "ReceiveLatencyTestResults"
    };
}

// receive messages
export interface IApprovedParcelBid {
    parcelBidId: string;
    bidAmount: number;
    bidReceivedTime: string;
    checkoutToken: string;
    parcelId: string;
    endTime: string;
}
export interface IBidderEnBlocApproval {
    parcelId: string;
    isApproved: boolean;
}
export interface IAdminEnBlocApprovedBidders {
    parcelId: string;
    approvedBidderIds: string[];
}
export interface IAuctionLiveUpdate {
    auctionId: string;
    live: boolean;
    completed: boolean;
}
export interface IParcelBidLogUpdate {
    parcelId: string;
    bidLog: IParcelBidLog;
}
export interface IParcelClocksUpdate {
    nextMessageDueTime: string;
    currentServerTime: string;
    liveParcels: IPublicParcelState[]; // Parcels from live auctions. Note the parcels might not be live.
}
export interface IParcelLiveStatus {
    parcelId: string;
    startDate: string;
    endDate: string;
    isLive: boolean;
    isCompleted: boolean;
}
export interface IBatchLiveUpdate {
    auctions: IAuctionLiveUpdate[];
    parcels: IParcelLiveStatus[];
}
export interface IBidProcessingComplete {
    parcelId: string;
    parcelBidId?: string;
    result: BidLoadState;
    errorText: string;
    checkoutToken: string;
    lastAcceptedBid: number;
}

export interface ILatencyTestResults {
    startTime: string;
    processedTime: string;
}
